import { AfterViewInit, Component, OnInit,ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DashboarduiService } from 'src/app/components/Shared/Service/dashboardui.service';
export class idsProductList {
  HotelCode: any;
  HotelName: any;
  HotelCity: any;
  HotelCountry: any;
  lastHeartBeat: any;
  CM: any;
  fxcrs: any;
  others:any;
  id: any;
  status: any;
  // hotelName: any;
  accountingDate: any;
  pusheddate: any;
  type:any
  Channelname:any
  Productname:any
}
@Component({
  selector: 'app-listdhproductsummarydetails',
  templateUrl: './listdhproductsummarydetails.component.html',
  styleUrls: ['./listdhproductsummarydetails.component.css']
})
export class ListdhproductsummarydetailsComponent implements OnInit {

  channelName: string = '';
  ProductName:string='';
  channelManagerDetails: any[] = [];
  isProgressing:boolean;
  ProductDetails:any[]=[];
  filteredDetails: any[] = [];
  statisticsData: any[] = [];
  selectedDetails: any[] = [];
  selectedChannelDetails: any[] = [];
   totalRecords: number = 0; // Total available records in the database
  //pageSize: number = 50; // Records per page
  pageIndex: number = 0; // Current page index
  filterProperty: any;
  Val: any;
  ValSearchDownload: string;
  searchBarFilter: boolean = false;
  dataSource: MatTableDataSource<idsProductList>
 idsProductList: idsProductList[] = [];
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  public PGF: any = 0;
  public PGT: any = 50;
  totalcount: any = 0;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private route: ActivatedRoute,public router:Router,private apiService: DashboarduiService,private toastr: ToastrService) { }


  ngOnInit() {
    this.readdhsummarydetails();
  }
  readdhsummarydetails() {
    this.route.paramMap.subscribe(params => {
        this.channelName = params.get('CHANNELNAME') || '';
        this.ProductName = params.get('ProductName') || '';
    });

    if (this.channelName !== '') {
        this.apiService.readdhsummarydetails().subscribe(data => {
            if (data && data.ChannelManagerDetails) {
                this.channelManagerDetails = data.ChannelManagerDetails;
                this.filteredDetails = this.channelManagerDetails.filter(detail => detail.CHANNELNAME === this.channelName);
                this.totalcount = this.filteredDetails.length;
                console.log("Channelsname length",this.totalcount)
               /*  if (this.totalcount < 1) {
                  this.toastr.error('No Data Found');
                  console.log(this.totalcount)
                  this.errorMsgSubscription = true
                  this.errorMessage = "No Data Found"
                  this.displayContent = false
                  this.isProgressing = false;
        
                }
                else {
                  this.idsProductList = data;
                  console.log('response ==',this.filteredDetails)
                  //this.totalcount = this.StorelstRestr.length;
                  console.log('totalcount ==',this.totalcount)
                  this.errorMsgSubscription = false
                  this.displayContent = true
                  this.filteredDetails = this.idsProductList
                  this.dataSource = new MatTableDataSource(this.idsProductList);
                  this.dataSource.paginator = this.paginator;
                  this.toastr.success('Data loaded Successfully');
                  this.isProgressing = false;
                } */
            }
        });
    } else if (this.ProductName !== '') {
        this.apiService.readdhsummarydetails().subscribe(data => {
            if (data && data.ProductDetails) {
                this.ProductDetails = data.ProductDetails;
                this.filteredDetails = this.ProductDetails.filter(detail => detail.ProductName === this.ProductName);
                this.totalcount = this.filteredDetails.length;
                console.log("ProductName length",this.totalcount)
                this.toastr.success('Data loaded Successfully');
            }
        });
    } else {
        this.filteredDetails = this.ProductDetails.filter(detail => detail.ProductName === this.ProductName);
        this.totalcount = this.filteredDetails.length;

    }
}
goBack() {
  this.router.navigate(['/DHProductSummaryDetails']);
} 
filterResults() {
  const searchValue = this.ValSearchDownload.trim().toLowerCase();
  if (!searchValue) {
    this.filteredDetails = this.channelName 
      ? this.channelManagerDetails.filter(detail => detail.CHANNELNAME === this.channelName)
      : this.ProductDetails.filter(detail => detail.ProductName === this.ProductName);
    return;
  }

  this.filteredDetails = this.filteredDetails.filter(detail =>
    (detail.HotelName && detail.HotelName.toLowerCase().includes(searchValue)) ||
    (detail.HotelCode && detail.HotelCode.toLowerCase().includes(searchValue))
  );
}

onRowClick(detail: any) {
  this.selectedDetails = [detail]; // Display selected detail separately
}
}
